import React from 'react'
import {connect} from 'react-redux'
import {Popover} from 'common/Popover'
import {Icon} from 'common/LegacyIcon'
import {alignFix} from './GalleryBlock.scss'
import * as reportActions from 'lib/api/rideReports'
const preventDefault = e => e.preventDefault()

export const GalleryPopover = ({setFeaturedImage, reportId, isFeatured, reselectPhotos, displayAsPostcard, editingPostcard,
  canEmbiggen, size, imageIds, toggleEditPostcard, embiggen, shrink,
  togglePostcard, toggleHelp}) =>
  (
    <Popover onMouseDown={preventDefault}>
      {imageIds.length === 1 && (
        isFeatured
          ? <li className={alignFix}><Icon i='star' size={16} alignMiddle={false} /><span> current cover image</span></li>
          : <li onClick={() => setFeaturedImage(reportId, imageIds[0])}>set as cover</li>
      )}
      <li onClick={reselectPhotos}>change photos</li>
      {displayAsPostcard && (editingPostcard
        ? <li onClick={toggleEditPostcard}>done editing</li>
        : <li onClick={toggleEditPostcard}>reposition photos</li>)}
      {canEmbiggen && (size === 'normalBlock'
        ? <li onClick={embiggen}>bigger</li>
        : <li onClick={shrink}>smaller</li>)}
      {imageIds.length > 1 && (displayAsPostcard
        ? <li onClick={togglePostcard}>switch to gallery</li>
        : <li onClick={togglePostcard}>switch to postcard</li>)}
      <li onClick={toggleHelp}><Icon i='help' size={14} /> help</li>
    </Popover>
  )

const mapDispatchToProps = {
  setFeaturedImage: reportActions.setFeaturedImage
}

const mapStateToProps = (state, ownProps) => ({
  isFeatured: ownProps.imageIds && ownProps.imageIds.length === 1 && ownProps.imageIds[0] === state.rideReports.reports.get(ownProps.reportId).featuredImage
})

export const GalleryPopoverContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(GalleryPopover)
